/*
 * zeroLabs eigenes JavaScript. Geladen mit defer über snippets/zl-head.liquid,
 * blockiert also weder Laden noch Kauf.
 * Bewegung nur als Antwort auf eine Handlung und nur, wenn zl.motionOk() true ist.
 */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  window.zl = window.zl || {};
  window.zl.motionOk = () => !reduced.matches;

  // Reduzierte Bewegung: automatische Slides anhalten und Videos, die von selbst laufen, stoppen.
  const calm = () => {
    if (window.zl.motionOk()) return;
    document.querySelectorAll('[data-autoplay="true"]').forEach((el) => {
      const slider = window.Flickity && window.Flickity.data(el);
      if (slider && typeof slider.stopPlayer === 'function') slider.stopPlayer();
    });
    document.querySelectorAll('video[autoplay]').forEach((video) => {
      video.pause();
      video.removeAttribute('autoplay');
    });
  };
  window.addEventListener('load', calm);
  reduced.addEventListener('change', calm);

  // Teaser auf der Startseite (sections/zl-teaser.liquid). Der Besucher wischt, der Browser rastet ein.
  // Punkte und Pfeile springen zur Folie, bei reduzierter Bewegung ohne Gleiten. Nichts läuft von selbst.
  const initTeaser = (root) => {
    if (!root || root.dataset.zlReady) return;
    root.dataset.zlReady = '1';
    const track = root.querySelector('[data-zl-teaser-track]');
    const slides = [...root.querySelectorAll('[data-zl-teaser-slide]')];
    const dots = [...root.querySelectorAll('[data-zl-teaser-dot]')];
    const prev = root.querySelector('[data-zl-teaser-prev]');
    const next = root.querySelector('[data-zl-teaser-next]');
    if (!track || slides.length < 2) return;

    const current = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    // Ziel einer laufenden Fahrt, damit schnelle Klicks nicht auf halbem Weg neu rechnen
    let pending = null;
    const base = () => (pending === null ? current() : pending);
    const go = (i) => {
      const target = Math.max(0, Math.min(slides.length - 1, i));
      pending = target;
      track.scrollTo({ left: target * track.clientWidth, behavior: window.zl.motionOk() ? 'smooth' : 'auto' });
    };
    const update = () => {
      if (pending !== null && Math.abs(track.scrollLeft - pending * track.clientWidth) < 2) pending = null;
      const i = current();
      dots.forEach((dot, n) => {
        if (n === i) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    };

    let frame = 0;
    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; update(); });
    }, { passive: true });
    // Fasst der Besucher selbst an, gilt wieder die Position unter dem Finger
    ['pointerdown', 'wheel', 'touchstart'].forEach((type) => track.addEventListener(type, () => { pending = null; }, { passive: true }));
    track.addEventListener('scrollend', () => { pending = null; update(); });
    dots.forEach((dot, n) => dot.addEventListener('click', () => go(n)));
    if (prev) prev.addEventListener('click', () => go(base() - 1));
    if (next) next.addEventListener('click', () => go(base() + 1));
    root.addEventListener('keydown', (event) => {
      if (event.target.closest('input, textarea, select')) return;
      if (event.key === 'ArrowLeft') { go(base() - 1); event.preventDefault(); }
      if (event.key === 'ArrowRight') { go(base() + 1); event.preventDefault(); }
    });
    // Theme-Editor: ausgewählte Folie zeigen
    root.addEventListener('shopify:block:select', (event) => {
      const n = slides.indexOf(event.target);
      if (n > -1) go(n);
    });
    update();
  };
  // Höhe des festen Kopfs am Handy genau nachmessen (Rückfall in zl-tokens.css: --zl-header-mobile)
  const headerHeight = () => {
    const header = document.querySelector('.header-wrapper');
    if (!header || getComputedStyle(header).position !== 'fixed') return;
    document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
  };
  const initAllTeasers = () => {
    document.querySelectorAll('[data-zl-teaser]').forEach(initTeaser);
    // Auf jeder Seite: Die erste Sektion rückt am Handy um die Höhe des festen Kopfs nach unten (zl-seiten.css)
    headerHeight();
    window.addEventListener('resize', headerHeight, { passive: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllTeasers);
  else initAllTeasers();
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-zl-teaser]').forEach(initTeaser);
  });
})();

// Textseiten: Ein Absatz, der nur aus fettem Text besteht, ist eine Zwischenüberschrift
// (so sind AGB, Versand, Datenschutz und Widerruf im Editor gebaut). Er bekommt die Klasse
// zl-zwischentitel, zl-seiten.css gibt ihm den Takt einer Überschrift. Fett mit Text dahinter
// ("Hinweis: ...") bleibt ein normaler Absatz. Der Text selbst bleibt unverändert.
(() => {
  const mark = (root) => {
    root.querySelectorAll('main :is(.rte, .rte-setting) > p').forEach((p) => {
      const only = p.children.length === 1 ? p.children[0] : null;
      if (!only || !/^(STRONG|B)$/.test(only.tagName)) return;
      if (p.textContent.trim() !== only.textContent.trim() || !p.textContent.trim()) return;
      p.classList.add('zl-zwischentitel');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mark(document));
  else mark(document);
  document.addEventListener('shopify:section:load', (event) => mark(event.target));
})();

// Infoseiten, Video (sections/zl-info-video.liquid): YouTube lädt erst, wenn der Besucher auf Abspielen drückt.
// Vorher geht keine Anfrage an YouTube. Danach youtube-nocookie.com, das Video startet sofort.
(() => {
  document.addEventListener('click', (event) => {
    const start = event.target.closest('[data-zl-video]');
    if (!start) return;
    const frame = document.createElement('iframe');
    frame.src = start.dataset.zlVideo;
    frame.title = start.dataset.zlVideoTitel || 'Video';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    start.replaceWith(frame);
    frame.focus();
    // Wer aus dem Bild scrollt, hält den Film an. Der Befehl geht als Nachricht an den Player, ohne Skript von YouTube.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((eintraege) => {
        eintraege.forEach((e) => {
          if (!e.isIntersecting && frame.contentWindow) frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', 'https://www.youtube-nocookie.com');
        });
      }).observe(frame);
    }
  });
})();

// Auftritt von Text (CLAUDE.md, Gestaltungsgrammatik): Ein Block mit data-zl-auftritt tritt einmal auf, wenn seine
// Oberkante --zl-auftritt-start der Bildschirmhöhe erreicht. Seine Kinder kommen nacheinander, mit data-zl-auftritt="ganz"
// der Block als Ganzes. Was im selben Moment auftritt, wird um --zl-auftritt-staffel versetzt. Weg, Dauer und Kurve stehen
// in zl-tokens.css, der Übergang in zl-custom.css. Was beim Laden schon im Bild steht oder darüber, ist sofort da.
// Bei reduzierter Bewegung tritt nichts auf, alles steht.
(() => {
  const html = document.documentElement;
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (still.matches || !('IntersectionObserver' in window)) return;
  // Vergleich am Gerät: ?zl-auftritt=vorher oder =ruhig gilt für die ganze Sitzung, =standard nimmt es zurück (Werte in zl-tokens.css)
  try {
    const probe = new URLSearchParams(location.search).get('zl-auftritt');
    if (probe) sessionStorage.setItem('zl-auftritt', probe);
    const gewaehlt = sessionStorage.getItem('zl-auftritt');
    if (gewaehlt && gewaehlt !== 'standard') html.setAttribute('data-zl-auftritt-probe', gewaehlt);
  } catch (e) { /* ohne Speicher gilt der Standard */ }
  // Zeiten mit Einheit lesen: Shopify verkleinert die CSS-Datei und schreibt 150ms dabei als .15s
  const wert = (name) => {
    const roh = getComputedStyle(html).getPropertyValue(name).trim();
    const zahl = parseFloat(roh);
    return /\ds$/.test(roh) && !/ms$/.test(roh) ? zahl * 1000 : zahl;
  };
  const start = wert('--zl-auftritt-start') || 1;
  const staffel = wert('--zl-auftritt-staffel') || 0;
  // Kinder mit data-zl-auftritt-bleibt (eine Zahl oder Szene im Kopf) stehen von Anfang an und zählen in der Staffel nicht mit
  const teile = (block) => (block.dataset.zlAuftritt === 'ganz' || !block.children.length ? [block] : [...block.children].filter((k) => !k.hasAttribute('data-zl-auftritt-bleibt')));

  // Blöcke mit data-zl-auftritt-js (jede Reihe zum Wischen, siehe vorbereiten) bewegt das Skript selbst, mit festen
  // Anfangs- und Endwerten statt per Übergang. Safari am iPhone startet bei Karten in einer Reihe zum Wischen zwar einen
  // Übergang, zeigt aber sofort den Endstand.
  const weg = getComputedStyle(html).getPropertyValue('--zl-auftritt-weg').trim();
  const kurve = getComputedStyle(html).getPropertyValue('--zl-auftritt-kurve').trim();
  const kurveSicht = getComputedStyle(html).getPropertyValue('--zl-auftritt-kurve-sicht').trim();
  const bewegen = (teil, verzug) => {
    teil.animate([{ transform: `translate(0, ${weg})` }, { transform: 'none' }], { duration: wert('--zl-auftritt-dauer'), delay: verzug, easing: kurve, fill: 'backwards' });
    teil.animate([{ opacity: 0 }, { opacity: 1 }], { duration: wert('--zl-auftritt-dauer-sicht'), delay: verzug + wert('--zl-auftritt-sicht-ab'), easing: kurveSicht, fill: 'backwards' });
  };

  // Messanzeige zum Prüfen am Gerät (?zl-auftritt-messen, gilt für die Sitzung): Lage und Deckkraft des ersten Teils
  // zu festen Zeitpunkten nach dem Auslösen, dazu die Verzögerung der Deckkraft, wie der Browser sie gelesen hat
  let messen = false;
  try {
    if (/[?&]zl-auftritt-messen/.test(location.search)) sessionStorage.setItem('zl-auftritt-messen', '1');
    messen = sessionStorage.getItem('zl-auftritt-messen') === '1';
  } catch (e) { /* ohne Speicher keine Anzeige */ }
  const messenZeigen = (teil) => {
    const marken = [0, 400, 800, 1000, 1200, 1600, 2000]; // token-ok: Zeitpunkte der Messanzeige in ms
    const werte = [];
    const t0 = performance.now();
    const probe = (jetzt) => {
      const t = jetzt - t0;
      while (werte.length < marken.length && t >= marken[werte.length]) {
        const stil = getComputedStyle(teil);
        werte.push(`${(marken[werte.length] / 1000).toFixed(1)} s: ${new DOMMatrix(stil.transform).f.toFixed(1)} px, ${Math.round(stil.opacity * 100)} %`);
      }
      if (werte.length < marken.length) { requestAnimationFrame(probe); return; }
      let box = document.getElementById('zl-auftritt-messen');
      if (!box) {
        box = document.createElement('pre');
        box.id = 'zl-auftritt-messen';
        box.style.cssText = 'position:fixed;top:var(--zl-space-2);left:var(--zl-space-2);z-index:2147483647;margin:0;padding:var(--zl-space-2);border-radius:var(--zl-radius-fest);background:var(--zl-ink);color:var(--zl-paper);font:var(--zl-small)/1.4 monospace;pointer-events:none;white-space:pre'; // token-ok: Prüfanzeige, Zeilenhöhe
        document.body.append(box);
      }
      const stil = getComputedStyle(teil);
      box.textContent = [`Breite ${innerWidth}, Weg ${getComputedStyle(html).getPropertyValue('--zl-auftritt-weg').trim()}`, `Verzögerung ${stil.transitionDelay}`, ...werte].join('\n');
    };
    requestAnimationFrame(probe);
  };

  const zeigen = (bloecke) => {
    let i = 0;
    bloecke.forEach((block) => {
      const selbst = block.hasAttribute('data-zl-auftritt-js') && 'animate' in block;
      teile(block).forEach((teil) => {
        const verzug = Math.min(i, 3) * staffel; // höchstens vier Stufen, der Rest kommt mit der letzten
        if (selbst) bewegen(teil, verzug);
        else teil.style.setProperty('--zl-auftritt-verzug', `${verzug}ms`);
        i += 1;
      });
      block.classList.add('zl-auftritt-da');
    });
    if (messen) messenZeigen(teile(bloecke[0])[0]);
    // Wenn alle angekommen sind: Versetzung und Übergang wieder weg, Buttons und Links behalten ihre eigenen Übergänge
    const dauer = Math.max(wert('--zl-auftritt-dauer'), wert('--zl-auftritt-sicht-ab') + wert('--zl-auftritt-dauer-sicht')) + Math.min(i, 4) * staffel;
    setTimeout(() => bloecke.forEach((block) => {
      teile(block).forEach((teil) => { teil.style.removeProperty('--zl-auftritt-verzug'); });
      block.classList.add('zl-auftritt-fertig');
    }), dauer + staffel);
  };

  // Das Band reicht von der Auslöselinie weit nach oben: Wer in einem Sprung darüber hinwegscrollt (schneller Wisch,
  // Sprung zu einem Anker, Rückkehr an die alte Stelle), löst trotzdem aus und findet keinen unsichtbaren Text darüber.
  const beobachter = new IntersectionObserver((eintraege) => {
    const jetzt = eintraege
      .filter((e) => e.isIntersecting)
      .map((e) => e.target)
      .sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
    jetzt.forEach((el) => beobachter.unobserve(el));
    if (jetzt.length) zeigen(jetzt);
  }, { rootMargin: `10000% 0px -${Math.round((1 - start) * 100)}% 0px` }); // token-ok: Band nach oben offen, 100 Bildschirmhöhen

  // spaet: der Block kommt erst nach dem Laden in die Seite (von einer App). Steht er dann schon im Bild, tritt er
  // gleich auf, statt plötzlich dazustehen. Steht er schon über dem Bild, ist er sofort da.
  // Eine Reihe zum Wischen (der Block selbst oder sein Elternteil scrollt waagerecht) bewegt das Skript selbst
  const wischt = (el) => !!el && /auto|scroll/.test(getComputedStyle(el).overflowX);
  const vorbereiten = (bereich, spaet) => {
    const jetzt = [];
    bereich.querySelectorAll('[data-zl-auftritt]:not(.zl-auftritt-da)').forEach((block) => {
      if (wischt(block) || wischt(block.parentElement)) block.setAttribute('data-zl-auftritt-js', '');
      const lage = block.getBoundingClientRect();
      // Ein Block ohne Größe (noch ausgeblendet) wartet, bis er Platz hat, statt sofort als angekommen zu gelten
      if (!lage.height || lage.top >= window.innerHeight * start) beobachter.observe(block);
      else if (spaet && lage.bottom > 0) jetzt.push(block);
      else block.classList.add('zl-auftritt-da', 'zl-auftritt-fertig');
    });
    if (jetzt.length) {
      document.body.offsetHeight; // der Ausgangszustand steht, bevor der Weg zum Platz beginnt
      zeigen(jetzt);
    }
  };

  // Bausteine, die eine App erst nach dem Laden in die Seite schreibt (etwa die Bewertungen), melden sich mit dem
  // Ereignis zl:auftritt an ihrem Element, dann werden ihre Blöcke wie alle anderen vorbereitet
  document.addEventListener('zl:auftritt', (event) => vorbereiten(event.target, true));

  const los = () => {
    vorbereiten(document);
    html.classList.add('zl-auftritt-an');
    document.addEventListener('shopify:section:load', (event) => vorbereiten(event.target));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los);
  else los();
})();

// Tinte: Wo der sichtbare Strich eines Zeichens beginnt, gemessen an den Pixeln, nicht an den Maßen, die der Browser
// meldet. Safari gibt in measureText() für die Luft vor dem Zeichen (actualBoundingBoxLeft) keinen brauchbaren Wert, Chrome
// schon; in Safari blieb der Text deshalb um die Luft rechts der Kante stehen (Moritz, 12.10.2026, Safari am Desktop).
// Jedes Zeichen wird je Schrift einmal groß auf eine unsichtbare Fläche gezeichnet, gesucht wird die erste Spalte mit
// Farbe. Ergebnis in px für die Schriftgröße des Elements: positiv = Luft vor dem Strich, negativ = das Zeichen ragt vor.
(() => {
  const GROESSE = 200; // token-ok: Zeichengröße der Messung, ein Pixel ist ein halbes Prozent der Schriftgröße
  const merk = new Map();
  let flaeche = null;
  window.zlTinte = (zeichen, stil) => {
    const fs = parseFloat(stil && stil.fontSize) || 0;
    if (!zeichen || !fs) return 0;
    const schrift = `${stil.fontStyle || 'normal'} ${stil.fontWeight} ${GROESSE}px ${stil.fontFamily}`;
    const schluessel = `${schrift}|${zeichen}`;
    if (!merk.has(schluessel)) {
      if (!flaeche) {
        const c = document.createElement('canvas');
        c.width = GROESSE * 3; c.height = GROESSE * 2;
        flaeche = c.getContext('2d', { willReadFrequently: true });
      }
      const b = flaeche.canvas.width;
      const h = flaeche.canvas.height;
      flaeche.clearRect(0, 0, b, h);
      flaeche.font = schrift;
      flaeche.textAlign = 'left';
      flaeche.textBaseline = 'alphabetic';
      flaeche.fillStyle = '#000'; // token-ok: Messfarbe auf der unsichtbaren Fläche, nie zu sehen
      flaeche.fillText(zeichen, GROESSE, GROESSE * 1.4); // token-ok: Platz links und oben für Zeichen, die vorragen
      const d = flaeche.getImageData(0, 0, b, h).data;
      let links = -1;
      for (let x = 0; x < b && links < 0; x += 1) {
        for (let y = 0; y < h; y += 1) {
          if (d[(y * b + x) * 4 + 3] > 127) { links = x; break; } // token-ok: halb gedeckt zählt als Strich, wie das Auge
        }
      }
      merk.set(schluessel, links < 0 ? 0 : (links - GROESSE) / GROESSE);
    }
    return merk.get(schluessel) * fs;
  };
})();

// Optische Kante (docs/abstaende.md, Linke Kante): Linksbündig heißt optisch bündig. Große Schrift hat vor dem ersten
// Buchstaben Luft im Zeichen (bei einer 200 px großen 1 rund 6 px, bei einer Überschrift mit D rund 3 px). Jeder Textblock
// in eigenen Bausteinen rückt um genau diese Luft seines ersten Zeichens nach links, so steht der sichtbare Strich auf
// derselben Kante wie Logo, Etiketten, Buttons und Bilder. Auch ein Anführungszeichen am Anfang steht auf der Kante,
// Satzzeichen hängen nicht. Gemessen wird erst mit beiden Schnitten der Schrift.
// Ausgenommen: mittig oder rechts gesetzter Text, Text mit Marker dahinter, die Show (zl-teaser-labor.js stellt ihre Kante
// selbst) und Blöcke mit eigenem Rand links. Mit ?zl-kante zeigt eine Linie an der Kante des Logos, ob alles darauf steht.
(() => {
  const html = document.documentElement;
  const TEXT = 'h1, h2, h3, h4, h5, h6, p, blockquote, li, dt, dd, figcaption, div, span, strong, b, a';
  const AUSWAHL = `main [class*="zl-"] :is(${TEXT}), main :is(${TEXT})[class*="zl-"], [data-zl-kante], .jdgm-carousel-wrapper :is(.jdgm-carousel-title, .jdgm-all-reviews-rating-wrapper), .jdgm-carousel-wrapper .jdgm-carousel-title-and-link :is(${TEXT}), .jdgm-carousel-wrapper .jdgm-carousel-item :is(${TEXT})`;
  const AUSSER = '[data-zl-tl], [data-zl-kante="aus"], svg, button, .btn';
  const gestellt = new WeakSet();
  const strichVon = (knoten, i) => {
    const r = document.createRange(); r.setStart(knoten, i); r.setEnd(knoten, i + 1);
    const k = r.getClientRects()[0];
    if (!k) return null;
    const cs = getComputedStyle(knoten.parentElement);
    return { links: k.left + window.zlTinte(knoten.textContent[i], cs), oben: k.top, hoehe: k.height, groesse: parseFloat(cs.fontSize) || 0 };
  };
  // Große Schrift über mehrere Zeilen: Jede weitere Zeile bekommt die Luft ihres eigenen ersten Zeichens, sonst steht
  // eine Zeile mit W 5 px neben einer Zeile mit E (bei 86 px). kante = wo der sichtbare Strich stehen soll.
  // Auch für die Show (zl-teaser-labor.js) als window.zlZeilenKante.
  // Getrennt in Lesen (anfaengeVon) und Schreiben (anfaengeSetzen): Liest der Browser nach jeder Änderung neu, rechnet er
  // die ganze Seite jedes Mal neu durch (gemessen am 15.10.2026: 3 s beim Laden des Adventskalenders am Desktop).
  const anfaengeVon = (el) => {
    const anfaenge = [];
    let oben = null;
    const gang2 = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let k2;
    while ((k2 = gang2.nextNode())) {
      for (let i = 0; i < k2.textContent.length; i += 1) {
        if (!k2.textContent[i].trim()) continue;
        const st = strichVon(k2, i);
        if (!st) continue;
        if (oben === null) { oben = st.oben; continue; }
        if (st.oben - oben > st.hoehe / 2) { anfaenge.push([k2, i, st.links, st.groesse]); oben = st.oben; }
      }
    }
    return anfaenge;
  };
  const anfaengeSetzen = (kante, anfaenge) => {
    anfaenge.slice().reverse().forEach(([k3, i, links, groesse]) => {
      const rand = kante - links;
      if (Math.abs(rand) < 0.3) return;
      // Die Luft vor einem Zeichen ist höchstens ein Fünftel seiner Größe. Steht ein Zeichen weiter weg, beginnt dort keine
      // Zeile, sondern etwas Eigenes liegt darunter (etwa die nächste Ziffer einer Zahl, die hochzählt)
      if (groesse && Math.abs(rand) > groesse * 0.2) return; // token-ok: Anteil der Schriftgröße
      const rest = k3.splitText(i);
      rest.splitText(1);
      const sp = document.createElement('span');
      sp.dataset.zlZeilenanfang = '';
      sp.style.marginLeft = `${rand.toFixed(1)}px`;
      rest.replaceWith(sp);
      sp.appendChild(rest);
    });
  };
  const zuruecknehmen = (el) => {
    const alt = el.querySelectorAll('span[data-zl-zeilenanfang]');
    if (!alt.length) return;
    alt.forEach((sp) => sp.replaceWith(...sp.childNodes));
    el.normalize();
  };
  const zeilenStellen = (el, kante) => {
    zuruecknehmen(el);
    anfaengeSetzen(kante, anfaengeVon(el));
  };
  window.zlZeilenKante = zeilenStellen;

  const ersteZeichen = (el) => {
    const gang = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let knoten;
    while ((knoten = gang.nextNode())) {
      const i = knoten.textContent.search(/\S/);
      if (i >= 0) return [knoten.textContent[i], knoten.parentElement];
    }
    return null;
  };

  const stellen = (bereich = document) => {
    const liste = [];
    if (bereich !== document && bereich.matches && bereich.matches(AUSWAHL)) liste.push(bereich);
    liste.push(...bereich.querySelectorAll(AUSWAHL));
    // Ein Raster oder eine Reihe aus Textzeilen (etwa zwei Sätze übereinander, von denen einer sichtbar ist): jede Zeile für sich
    liste.slice().forEach((el) => {
      if (/^(grid|flex)$/.test(getComputedStyle(el).display)) liste.push(...[...el.children].filter((k) => getComputedStyle(k).display === 'block'));
    });
    // In Durchgängen: erst alle eigenen Korrekturen zurücknehmen (nur schreiben), dann alles messen (nur lesen), dann alle
    // Ränder setzen, dann alle Zeilenanfänge messen, dann setzen. So rechnet der Browser die Seite nur wenige Male durch,
    // nicht einmal je Element und je Zeichen (gemessen am 15.10.2026: 3 s beim Laden des Adventskalenders am Desktop, davon
    // fast alles erzwungenes Neuberechnen; Moritz: Die Animation kam deshalb erst nach 5 s).
    liste.forEach((el) => {
      // Eigene Korrektur aus einem früheren Durchgang zuerst zurücknehmen: Was jetzt nicht mehr passt (etwa ein Block, der
      // mit der Gestaltung zur Reihe wurde), behält sonst einen alten Rand
      if (gestellt.has(el)) { el.style.removeProperty('margin-left'); gestellt.delete(el); }
      // Zeilenanfänge aus einem früheren Durchgang wieder zu Text machen
      zuruecknehmen(el);
    });
    const plan = [], geplant = new Set();
    liste.forEach((el) => {
      if (geplant.has(el) || el.closest(AUSSER)) return; // ein Element kann zweimal in der Liste stehen, gestellt wird es einmal
      // Nur Blöcke, deren erstes Kind Text ist (kein Bild, kein Symbol davor)
      const erstes = [...el.childNodes].find((n) => n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim()));
      if (!erstes || (erstes.nodeType === 1 && /^(IMG|SVG|PICTURE|svg|BUTTON|INPUT)$/.test(erstes.tagName))) return;
      // Nur Textblöcke ohne eigene Blöcke darin, sonst rückte ein Kind zweimal (mit dem Elternteil und für sich)
      if ([...el.children].some((k) => { const d = getComputedStyle(k).display; return d !== 'none' && d !== 'contents' && !d.startsWith('inline'); })) return;
      if (el.style.marginLeft) return; // eigener Rand links aus einem anderen Baustein
      const cs = getComputedStyle(el);
      if (cs.display !== 'block' || !/^(left|start)$/.test(cs.textAlign) || cs.direction === 'rtl') return;
      if (parseFloat(cs.marginLeft) !== 0 || parseFloat(cs.paddingLeft) !== 0) return;
      const vorn = getComputedStyle(el, '::before');
      if (vorn.content !== 'none' && vorn.content !== 'normal') return;
      // Erstes Zeichen auf die Kante, auch wenn es ein Anführungszeichen ist: Satzzeichen hängen nicht (docs/abstaende.md)
      const z = ersteZeichen(el);
      if (!z) return;
      const luft = window.zlTinte(z[0], getComputedStyle(z[1]));
      geplant.add(el);
      plan.push({ el, luft, gross: parseFloat(cs.fontSize) >= 24 }); // token-ok: darunter ist die Luft kleiner als ein Pixel
    });
    plan.forEach((p) => {
      if (Math.abs(p.luft) >= 0.3) { p.el.style.marginLeft = `${(-p.luft).toFixed(1)}px`; gestellt.add(p.el); }
    });
    // Große Schrift über mehrere Zeilen: Jede weitere Zeile bekommt die Luft ihres eigenen ersten Zeichens
    // Die Kante neu lesen: Ein Rand an einem Element davor kann dieses verschoben haben (etwa in einer Reihe). Der eigene Rand
    // zählt nicht, die Kante ist, wo der Kasten ohne ihn stand.
    const zeilen = plan.filter((p) => p.gross).map((p) => [p.el.getBoundingClientRect().left - (parseFloat(p.el.style.marginLeft) || 0), anfaengeVon(p.el)]);
    zeilen.forEach(([kante, anfaenge]) => anfaengeSetzen(kante, anfaenge));
    // Ändert sich später die Höhe eines großen Texts (eine App zeigt ihn erst nach dem Stellen, eine Regel ändert seine Größe),
    // bricht er anders um: dann werden seine Zeilenanfänge neu gestellt. Gemessen am 20.10.2026 an der Überschrift über den
    // Bewertungen am Handy: die zweite Zeile stand 0,8 px neben der Kante, bis die Seite neu gemessen wurde.
    if (beobachter) plan.filter((p) => p.gross).forEach((p) => { if (!hoehen.has(p.el)) { hoehen.set(p.el, null); beobachter.observe(p.el); } });
  };
  const hoehen = new WeakMap();
  const neuGestellt = new WeakMap();
  const beobachter = window.ResizeObserver ? new ResizeObserver((eintraege) => {
    eintraege.forEach((e) => {
      const h = Math.round(e.contentRect.height);
      const alt = hoehen.get(e.target);
      hoehen.set(e.target, h);
      if (alt === null || alt === undefined || alt === h || !schriftDa) return;
      // Höchstens dreimal je Element: ein Zeilenanfang, der den Umbruch selbst verschiebt, schaukelt sich nicht auf
      const n = (neuGestellt.get(e.target) || 0) + 1;
      neuGestellt.set(e.target, n);
      if (n <= 3) stellen(e.target); // token-ok: Anzahl
    });
  }) : null;

  const linie = () => {
    if (!/[?&]zl-kante/.test(location.search)) return;
    const logo = document.querySelector('.site-header__logo svg, .site-header__logo img, .header-item--logo svg, .header-item--logo img');
    if (!logo) return;
    let strich = document.getElementById('zl-kante-linie');
    if (!strich) {
      strich = document.createElement('div');
      strich.id = 'zl-kante-linie';
      strich.style.cssText = 'position:fixed;top:0;bottom:0;width:1px;background:#ff3cac;z-index:99999;pointer-events:none'; // token-ok: Prüflinie, nur mit ?zl-kante
      document.body.appendChild(strich);
    }
    strich.style.left = `${logo.getBoundingClientRect().left}px`;
  };

  let schriftDa = false;
  const alles = () => { if (schriftDa) stellen(); linie(); };
  const fertig = () => { schriftDa = true; alles(); };
  if (document.fonts && document.fonts.load) {
    const familie = '"halfourgroteskzerolabs-regular-webfont"';
    Promise.all([document.fonts.load(`400 1em ${familie}`), document.fonts.load(`500 1em ${familie}`)]).then(fertig, fertig); // token-ok: Gewicht und Größe nur, um den Schnitt anzufragen
  } else fertig();
  let takt = 0;
  window.addEventListener('resize', () => { clearTimeout(takt); takt = setTimeout(alles, 150); }, { passive: true }); // token-ok: nach dem Ziehen des Fensters einmal neu messen
  // Bausteine, die eine App erst später schreibt (Bewertungen), melden sich wie beim Auftritt mit zl:auftritt
  document.addEventListener('zl:auftritt', (event) => { if (schriftDa) stellen(event.target); });
  document.addEventListener('shopify:section:load', (event) => { if (schriftDa) stellen(event.target); });
  window.zlKante = (bereich) => { if (schriftDa) stellen(bereich || document); };
})();
